import {DataCollaborator} from 'auth/PermissionConstants';
import * as net from 'util/Net';
import {UpdateWorklistParams} from 'worklists/WorklistActions';

import {
  Worklist,
  WorklistSummariesById,
  WorklistType,
  WorklistWithOwnerAndCollaborators,
} from './WorklistConstants';

export function bulkFetchWorklistSummaries(worklistIds: Array<string>): Promise<WorklistSummariesById> {
  return net.postJSONPromise({url: '/1/api/worklists:bulk-get', data: {worklistIds}});
}

export function createWorklist(
  worklistName: string,
  worklistItemType: WorklistType,
  itemIds: Array<string>,
  collaborators: Array<DataCollaborator> | null
): Promise<{newWorklist: WorklistWithOwnerAndCollaborators; worklistSummaries: WorklistSummariesById}> {
  return net.postJSONPromise({
    url: '/1/api/worklists',
    data: {
      worklistName,
      worklistItemType,
      itemIds,
      collaborators,
    },
  });
}

export function bulkDeleteWorklists(worklistIds: Array<string>): Promise<WorklistSummariesById> {
  return net.deletePromise({url: '/1/api/worklists:bulk-delete', data: {worklistIds}});
}

export function fetchWorklist(worklistId: string): Promise<Worklist> {
  return net.getJSONPromise(`/1/api/worklists/${worklistId}`);
}

export function updateWorklist(
  worklistId: string,
  data: UpdateWorklistParams
): Promise<WorklistWithOwnerAndCollaborators> {
  return net.patchJSONPromise({
    url: `/1/api/worklists/${worklistId}`,
    data,
  });
}

/**
 * TODO: If we find ourselves needing to bulk fetch items for many worklists at once,
 * implement bulk fetch endpoint for items in the API.
 */
export function bulkFetchWorklistItemIds(worklistIds: Array<string>): Promise<Array<Worklist>> {
  return Promise.all(worklistIds.map((id) => fetchWorklist(id)));
}

export function addItemsToWorklist(worklistId: string, itemIds: Array<string>): Promise<Worklist> {
  return net.patchJSONPromise({
    url: `/1/api/worklists/${worklistId}:add-items`,
    data: {
      itemIds,
    },
  });
}

export function removeItemsFromWorklist(worklistId: string, itemIds: Array<string>): Promise<Worklist> {
  return net.patchJSONPromise({
    url: `/1/api/worklists/${worklistId}:remove-items`,
    data: {
      itemIds,
    },
  });
}
